import { PlatformFinanceRepository } from '@lib/api/repository/platform-finance';
import {
  PlatformFinanceDashboard,
  PlatformFinanceFilters,
} from '@lib/types/platform-finance';

import { Requester } from '../clients';

interface DashboardDTO {
  gmvCents: number;
  tpvCents: number;
  refundedCents: number;
  commissionCents: number;
  withdrawalFeeCents: number;
  paidOutCents: number;
  availableCents: number;
  pendingCents: number;
  withdrawalPendingCents: number;
  frozenCents: number;

  currentMonth: string;
  currentMonthCents: number;
  totalCents: number;
  yearCents: number;
  months: Array<{
    month: string;
    commissionCents: number;
    withdrawalFeeCents: number;
    couponSubsidyCents?: number;
    totalCents: number;
  }>;
  entries: {
    total: number;
    items: Array<{
      id: string;
      type: 'commission' | 'withdrawal_fee' | 'coupon_subsidy';
      amountCents: number;
      effectiveAt: string;
      orderId?: string;
      withdrawalId?: string;
      storeName?: string;
    }>;
  };
}
export default class PlatformFinanceAPI implements PlatformFinanceRepository {
  async dashboard(
    filters: PlatformFinanceFilters,
    signal?: AbortSignal,
  ): Promise<PlatformFinanceDashboard> {
    const { data } = await Requester.get<DashboardDTO>(
      '/marketplace/admin/finance/dashboard',
      { params: { ...filters }, signal },
    );
    return {
      gmvCents: data.gmvCents,
      tpvCents: data.tpvCents,
      refundedCents: data.refundedCents,
      commissionCents: data.commissionCents,
      withdrawalFeeCents: data.withdrawalFeeCents,
      paidOutCents: data.paidOutCents,
      availableCents: data.availableCents,
      pendingCents: data.pendingCents,
      withdrawalPendingCents: data.withdrawalPendingCents,
      frozenCents: data.frozenCents,
      currentMonth: data.currentMonth,
      currentMonthCents: data.currentMonthCents,
      totalCents: data.totalCents,
      yearCents: data.yearCents,
      months: data.months.map((month) => ({
        month: month.month,
        commissionCents: month.commissionCents,
        withdrawalFeeCents: month.withdrawalFeeCents,
        couponSubsidyCents: month.couponSubsidyCents ?? 0,
        totalCents: month.totalCents,
      })),
      entries: {
        total: data.entries.total,
        items: data.entries.items.map((entry) => ({
          id: entry.id,
          type: entry.type,
          amountCents: entry.amountCents,
          effectiveAt: entry.effectiveAt,
          orderId: entry.orderId,
          withdrawalId: entry.withdrawalId,
          storeName: entry.storeName,
        })),
      },
    };
  }
}
